"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockUpdateTeamSubscriptionPaymentMethodResponse = exports.mockSetupPaymentMethodResponse = exports.mockTeamPlan = exports.mockTeam = exports.mockPaymentMethods = exports.getPlansResponse = exports.getPlansResponseReturning = void 0;
const BillingFrequency_1 = require("core/api/models/BillingFrequency");
const PaymentMethodType_1 = require("core/api/models/PaymentMethodType");
const TeamSubscriptionSupplier_1 = require("core/api/models/TeamSubscriptionSupplier");
const TeamSubscriptionTier_1 = require("core/api/models/TeamSubscriptionTier");
exports.getPlansResponseReturning = {
    productTable: {
        products: {
            prod_QMRPZ7pFB792ZR: {
                description: 'For larger teams looking to monetize sponsorships and receive premium support.',
                features: [
                    'Unlimited Roster Members',
                    'Photos and Files - Unlimited Storage',
                    'Schedule, Messages, and Payments',
                    'Health Check',
                    'Ad-free for Owner/Managers',
                    'Availability',
                    'TeamSnap Live!',
                    'Alerts and Reminders',
                    'Assignments',
                    'Lineups',
                    'Statistics',
                    'Customized Team Branding',
                    'Premium Support',
                    'Multiple Sponsorships',
                ],
                title: 'TeamSnap Ultra',
            },
            prod_QMROkOKUQRbFM6: {
                description: 'For teams wanting to also track stats and create shareable lineups.',
                features: [
                    '40 Roster Members',
                    'Photos and Files - 2 GB Storage',
                    'Schedule, Messages, and Payments',
                    'Health Check',
                    'Ad-free for Owner/Managers',
                    'Availability',
                    'TeamSnap Live!',
                    'Alerts and Reminders',
                    'Assignments',
                    'Lineups',
                    'Statistics',
                    'Customized Team Branding',
                    'Premium Support',
                ],
                title: 'TeamSnap Premium',
            },
            prod_QMRNXDlEk0gNLP: {
                description: 'For smaller teams who want to track availability and use reminders.',
                features: [
                    '30 Roster Members',
                    'Photos and Files - 500MB Storage',
                    'Schedule, Messages, and Payments',
                    'Health Check',
                    'Ad-free for Owner/Managers',
                    'Availability',
                    'TeamSnap Live!',
                    'Alerts and Reminders',
                    'Assignments',
                ],
                title: 'TeamSnap Basic',
            },
        },
        groups: [
            {
                title: 'Yearly',
                frequency: 'year',
                highlightedPriceId: 'price_1PViWGH3v9ZxQViIITBBAmSp',
                priceIntervalLabel: 'per year',
                productPrices: [
                    {
                        productId: 'prod_QMRNXDlEk0gNLP',
                        priceInCents: 7999,
                        badgeLabel: 'Save up to 45%',
                        ctaLabel: 'Subscribe',
                        priceId: 'price_1PViVZH3v9ZxQViIV2eZ39yH',
                    },
                    {
                        productId: 'prod_QMROkOKUQRbFM6',
                        priceInCents: 11999,
                        badgeLabel: 'Save up to 40%',
                        ctaLabel: 'Subscribe',
                        priceId: 'price_1PViWGH3v9ZxQViIITBBAmSp',
                    },
                    {
                        productId: 'prod_QMRPZ7pFB792ZR',
                        priceInCents: 14999,
                        badgeLabel: 'Save up to 40%',
                        ctaLabel: 'Subscribe',
                        priceId: 'price_1PViWtH3v9ZxQViILy3cxb4x',
                    },
                ],
            },
            {
                title: 'Monthly',
                frequency: 'month',
                highlightedPriceId: 'price_1PViVwH3v9ZxQViInIstchU9',
                priceIntervalLabel: 'per month',
                productPrices: [
                    {
                        productId: 'prod_QMRNXDlEk0gNLP',
                        priceInCents: 1199,
                        ctaLabel: 'Subscribe',
                        priceId: 'price_1PViV5H3v9ZxQViITxxBo1qN',
                    },
                    {
                        productId: 'prod_QMROkOKUQRbFM6',
                        priceInCents: 1599,
                        ctaLabel: 'Subscribe',
                        priceId: 'price_1PViVwH3v9ZxQViInIstchU9',
                    },
                    {
                        productId: 'prod_QMRPZ7pFB792ZR',
                        priceInCents: 2199,
                        ctaLabel: 'Subscribe',
                        priceId: 'price_1PViWeH3v9ZxQViIF67aS9HF',
                    },
                ],
            },
        ],
    },
};
exports.getPlansResponse = {
    productTable: {
        products: {
            prod_QMRPZ7pFB792ZR: {
                description: 'For larger teams looking to monetize sponsorships and receive premium support.',
                features: [
                    'Unlimited Roster Members',
                    'Photos and Files - Unlimited Storage',
                    'Schedule, Messages, and Payments',
                    'Health Check',
                    'Ad-free for Owner/Managers',
                    'Availability',
                    'TeamSnap Live!',
                    'Alerts and Reminders',
                    'Assignments',
                    'Lineups',
                    'Statistics',
                    'Customized Team Branding',
                    'Premium Support',
                    'Multiple Sponsorships',
                ],
                title: 'TeamSnap Ultra',
            },
            prod_QMROkOKUQRbFM6: {
                description: 'For teams wanting to also track stats and create shareable lineups.',
                features: [
                    '40 Roster Members',
                    'Photos and Files - 2 GB Storage',
                    'Schedule, Messages, and Payments',
                    'Health Check',
                    'Ad-free for Owner/Managers',
                    'Availability',
                    'TeamSnap Live!',
                    'Alerts and Reminders',
                    'Assignments',
                    'Lineups',
                    'Statistics',
                    'Customized Team Branding',
                    'Premium Support',
                ],
                title: 'TeamSnap Premium',
            },
            prod_QMRNXDlEk0gNLP: {
                description: 'For smaller teams who want to track availability and use reminders.',
                features: [
                    '30 Roster Members',
                    'Photos and Files - 500MB Storage',
                    'Schedule, Messages, and Payments',
                    'Health Check',
                    'Ad-free for Owner/Managers',
                    'Availability',
                    'TeamSnap Live!',
                    'Alerts and Reminders',
                    'Assignments',
                ],
                title: 'TeamSnap Basic',
            },
        },
        groups: [
            {
                title: 'Yearly',
                frequency: 'year',
                highlightedPriceId: 'price_1PViWGH3v9ZxQViIITBBAmSp',
                priceIntervalLabel: 'per year',
                productPrices: [
                    {
                        productId: 'prod_QMRNXDlEk0gNLP',
                        priceInCents: 7999,
                        badgeLabel: 'Save up to 45%',
                        ctaLabel: 'Start Trial',
                        priceId: 'price_1PViVZH3v9ZxQViIV2eZ39yH',
                        trialLengthInDays: 7,
                    },
                    {
                        productId: 'prod_QMROkOKUQRbFM6',
                        priceInCents: 11999,
                        badgeLabel: 'Save up to 40%',
                        ctaLabel: 'Start Trial',
                        priceId: 'price_1PViWGH3v9ZxQViIITBBAmSp',
                        trialLengthInDays: 7,
                    },
                    {
                        productId: 'prod_QMRPZ7pFB792ZR',
                        priceInCents: 14999,
                        badgeLabel: 'Save up to 40%',
                        ctaLabel: 'Start Trial',
                        priceId: 'price_1PViWtH3v9ZxQViILy3cxb4x',
                        trialLengthInDays: 7,
                    },
                ],
            },
            {
                title: 'Monthly',
                frequency: 'month',
                highlightedPriceId: 'price_1PViVwH3v9ZxQViInIstchU9',
                priceIntervalLabel: 'per month',
                productPrices: [
                    {
                        productId: 'prod_QMRNXDlEk0gNLP',
                        priceInCents: 1199,
                        ctaLabel: 'Start Trial',
                        priceId: 'price_1PViV5H3v9ZxQViITxxBo1qN',
                        trialLengthInDays: 7,
                    },
                    {
                        productId: 'prod_QMROkOKUQRbFM6',
                        priceInCents: 1599,
                        ctaLabel: 'Start Trial',
                        priceId: 'price_1PViVwH3v9ZxQViInIstchU9',
                        trialLengthInDays: 7,
                    },
                    {
                        productId: 'prod_QMRPZ7pFB792ZR',
                        priceInCents: 2199,
                        ctaLabel: 'Start Trial',
                        priceId: 'price_1PViWeH3v9ZxQViIF67aS9HF',
                        trialLengthInDays: 7,
                    },
                ],
            },
        ],
    },
};
exports.mockPaymentMethods = [
    {
        id: '1',
        card: {
            brand: 'Visa',
            last4: '4242',
            expiration: { year: 28, month: 1 },
        },
        type: PaymentMethodType_1.PaymentMethodType.CARD,
        isDefault: true,
    },
    {
        id: '2',
        card: {
            brand: 'Visa',
            last4: '1234',
            expiration: { year: 28, month: 12 },
        },
        type: PaymentMethodType_1.PaymentMethodType.CARD,
        isDefault: false,
    },
];
exports.mockTeam = { id: 1, name: 'Team Name' };
exports.mockTeamPlan = {
    tier: TeamSubscriptionTier_1.TeamSubscriptionTier.BASIC,
    capabilities: [],
    metadata: {
        paymentMethodId: '1',
        frequency: BillingFrequency_1.BillingFrequency.MONTH,
        supplier: TeamSubscriptionSupplier_1.TeamSubscriptionSupplier.STRIPE,
        expirationDate: '2022-01-01',
        isTrial: false,
        name: 'TeanSnap Basic',
    },
};
exports.mockSetupPaymentMethodResponse = {
    setupUrl: 'https://example.com',
};
exports.mockUpdateTeamSubscriptionPaymentMethodResponse = {
    success: true,
};
